import React from "react";
import eventBus from "src/utils/eventBus";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
  
  const handleOpenModal = () => {
    eventBus.emit("inquiryModal:show", { type: "success" });
  };
  
  return (
    <footer>
      <div className="container text-center pt-5 pb-5">
        <p className="fw-semibold">
          <a href="https://www.rudolphlabs.co.kr/" target="_blank" rel="noopener noreferrer">
            (주)루돌프랩스
          </a>
        </p>
        <small className="pt-3 d-inline-block text-black5">
          대표 : 최락운
          <span> | </span>
          주소 : 서울 영등포구 여의대방로 65길 17 703호
        </small>
        <br />
        <small className="pt-2 d-inline-block text-black5">
          사업자등록번호 : 164-88-01844
          <span> | </span>
          고객센터 {" "}
          {isMobile ? (
            <a href={"tel:02-786-9873"}>
                02-786-9873
            </a>
            ) : 
            <>
              02-786-9873
            </>
          }
        </small>
        <div className="btn-wrap mt-4 mb-4">
          <button className="btn btn-dark w-100 py-3" 
            style={{ maxWidth: "378px", borderRadius: "8px" }}
            onClick={() => handleOpenModal()}>문의하기
          </button>
        </div>
        <p className="text-black2 mb-4" style={{wordBreak: "keep-all"}}>
          텔레모아는 정보 제공의 목적으로 데이터를 수집 공유합니다.
          <br className="pc_only" />
          텔레모아의 내용은 부정확할 수 있으며 매매에 따른 손실은
          <br className="pc_only" />
          {" "}거래 당사자의 책임입니다. 해당 게시물의 내용은 어떠한 경우에도
          <br className="pc_only" />
          법적 근거로 사용될 수 없습니다.
        </p>
        <small className="text-black2">
          Copyright © {currentYear} 텔레모아. All rights reserved.
        </small>
      </div>
    </footer>
  );
};

export default Footer;
